<template>
  <div>
    <PageAllow controller="ThirdAccountInfo" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                      v-model="options"
                      type="datetime"
                      show-radios
                      :radios="datetimeRadios"
                      removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                          ref="keyword"
                          v-model="options.cash_ext_code"
                          @text="cash_ext_code = $event"
                          :label="$t('HuifuCash.Keyword')"
                  />
                </v-col>
                <!-- 汇付账户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherThirdAccount v-model="thirdAccountSelected" type="101"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="huifuCash"
            :loading="loading"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-2 px-4 pt-1 sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            id="sticky-table"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.ord_amt="{ item }">
              <span>
                {{ item.ord_amt.toFixed(2) }}
              </span>
            </template>
            <template v-slot:item.fee_amt>
              <span>
                {{ fee_amt.toFixed(2) }}
              </span>
            </template>
            <template v-slot:item.exp_cash_amt="{ item }">
              <span>
                {{ (item.ord_amt -1).toFixed(2) }}
              </span>
            </template>
            <template v-slot:item.req_time="{ item }">
              <span>
                 {{ item.req_time | formatTime }}
              </span>
            </template>
            <template v-slot:item.trans_status="{ item }">
              <v-chip
                small
                label
                :color="item.trans_status | huifuTransStatusColor"
                :text-color="item.trans_status | huifuTransStatusTextColor"
              >
                {{ item.trans_status | huifuTransStatusText }}
              </v-chip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherThirdAccount from "@/components/plugins/SearcherThirdAccount";
import ThirdAccountInfo from "@/api/third-account-info"

const defaultOptions = {
  datetimeRadioSelected: "req",
  req_time_from:
          new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
                  .toISOString()
                  .substr(0, 10) + " 00:00:00",
  req_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  cash_ext_code: "",
  third_account_id: 0,
  cash_type: 101,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherThirdAccount,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.thirdPayment"),
          disabled: false,
          href: "/huifu",
        },
        {
          text: i18n.t("Nav.huifuCash"),
          disabled: true,
          href: "/huifu-cash",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "req",
        text: i18n.t("HuifuCash.date"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("HuifuCash.Fields.companyName"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "third_account_info.company_name",
        },
        {
          text: i18n.t("HuifuCash.Fields.thirdAccountId"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "third_account_info.huifu_id",
        },
        {
          text: i18n.t("HuifuCash.Fields.ordAmt"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "ord_amt",
        },
        {
          text: i18n.t("HuifuCash.Fields.feeAmt"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "fee_amt",
        },
        {
          text: i18n.t("HuifuCash.Fields.expCashAmt"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "exp_cash_amt",
        },
        {
          text: i18n.t("HuifuCash.Fields.reqTime"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "req_time",
        },
        {
          text: i18n.t("HuifuCash.Fields.cardTokenNo"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "third_account_info.card_no",
        },
        {
          text: i18n.t("HuifuCash.Fields.transStatus"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "trans_status",
        },
        {
          text: i18n.t("HuifuCash.Fields.createrName"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "creater_name",
        },
        {
          text: i18n.t("HuifuCash.Fields.respDesc"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "resp_desc",
        }
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("huifuCash", ["thirdAccountSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "thirdAccountSelected":
              this.thirdAccountSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  data: () => ({
    huifuCash: [],
    cash_ext_code: "",
    thirdAccountSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("huifuCash-options")
        ? sessionStorage.getItem("huifuCash-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    fee_amt: 1.00
  }),

  methods: {
    resetSearch() {
      this.thirdAccountSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.cash_ext_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        cash_ext_code: this.cash_ext_code,
      });
    },
    getHuifuAccountFromAPI() {
      ThirdAccountInfo.getHuifuCashRecordList(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.huifuCash = response.data.third_cash_records;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getHuifuAccountFromAPI();
        sessionStorage.setItem(
          "huifuCash-options",
          JSON.stringify(this.options)
        );
      },
    },
    thirdAccountSelected: {
      handler() {
        this.options.third_account_id = this.thirdAccountSelected;
        sessionStorage.setItem(
                "huifu-thirdAccountSelected",
                JSON.stringify(this.thirdAccountSelected)
        );
      },
    },
  },
};
</script>